import { forwardRef, useState } from 'react';
import { Dialog, DialogContent, Grid, IconButton, Slide, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import perfectRxTheme from 'common/theme/perfectRxTheme';
import { filter, find, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import CustomizedAccordions from './ItemAccordion';
import PatientInfoCardView from './PatientInfoViewCard';

const Transition = forwardRef((props, ref) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Slide direction='up' ref={ref} {...props} timeout={300} />
));

const DuplicatePatientComparisonDialog = ({ onClose, showDialog, patients, mpi }) => {
  const [patientToCompare, setPatientToCompare] = useState({});
  const [patientIdentifier, setPatientIdentifier] = useState(null);

  const closeDialog = () => {
    onClose();
    setPatientToCompare({});
    setPatientIdentifier(null);
  };

  const hostPatient = find(patients, { patientId: mpi });
  const filteredPatients = filter(patients, (value) => value.patientId !== mpi);

  const handleOnComparePatient = (event) => {
    const selectedPatientId = event.mpi;
    setPatientIdentifier(event.patientIdentifier);

    setPatientToCompare(find(patients, { patientId: selectedPatientId }));
  };

  return (
    <Dialog
      aria-describedby='Duplicate-Patient-Comparison'
      fullScreen
      TransitionComponent={Transition}
      open={showDialog}
    >
      <Grid
        container
        sx={{ px: 2, p: 1, bgcolor: 'primary.light' }}
        justifyContent='space-between'
        alignItems='center'
      >
        <Grid
          container
          sx={{ px: 2, p: 1, bgcolor: 'primary.light' }}
          justifyContent='space-between'
          alignItems='center'
        >
          <Typography component='h2' variant='h6' color={perfectRxTheme.palette.text.light}>
            Duplicate Patients Management
          </Typography>

          <IconButton onClick={closeDialog} aria-label='Close Dialog'>
            <CloseIcon style={{ color: perfectRxTheme.palette.text.light }} />
          </IconButton>
        </Grid>
      </Grid>
      <DialogContent>
        <Grid container direction='row' sx={{ height: '100%' }} spacing={2}>
          <Grid item xs={2}>
            <CustomizedAccordions
              records={filteredPatients}
              onComparePatient={handleOnComparePatient}
            />
          </Grid>
          {!isEmpty(patientToCompare) && (
            <Grid item xs={5}>
              <PatientInfoCardView patientInfo={hostPatient} heading='Reference Patient' isSource />
            </Grid>
          )}

          <Grid item xs={5}>
            <PatientInfoCardView
              patientInfo={patientToCompare}
              heading={`Duplicate Patient Profile ${patientIdentifier}`}
              isSource={false}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

DuplicatePatientComparisonDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  showDialog: PropTypes.bool.isRequired,
  patients: PropTypes.arrayOf(
    PropTypes.shape({
      partner: PropTypes.shape({
        partnerName: PropTypes.string,
      }),
      patient: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        createdTime: PropTypes.string.isRequired,
        dob: PropTypes.string.isRequired,
        gender: PropTypes.string.isRequired,
      }),
      externalId: PropTypes.string,
      patientId: PropTypes.string.isRequired,
      practice: PropTypes.arrayOf(
        PropTypes.shape({
          practiceName: PropTypes.string,
        })
      ),
    })
  ).isRequired,
  mpi: PropTypes.bool.isRequired,
};

export default DuplicatePatientComparisonDialog;
